import React from "react";
import { ModalContainer } from "../partials/modalbackground";
import Check from "../../assets/icons/check-circle.svg";
import { useNavigate } from "react-router-dom";
import PrimaryBtn from "../partials/btn";

interface ModalProps {
	title?: string;
	desc?: string;
	btnText?: string;
	page?: string;
	onClick?: () => void;
	onClose?: () => void;
	loading?: boolean;
}

const SuccessModal: React.FC<ModalProps> = ({ title, desc, btnText, page }) => {
	const navigate = useNavigate();
	return (
		<div>
			<ModalContainer>
				<div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
					<div
						style={{
							border: "8px solid #ECFDF3",
						}}
						className="size-12 mx-auto rounded-full flex items-center justify-center bg-[#D1FADF]">
						<img src={Check} alt="" className="" />
					</div>
					<h2 className="text-lg mt-4 font-medium text-sec text-center">
						{title || "  ERP 1 Assessment Completed"}
					</h2>
					<p className="text-sm mt-4 font-normal text-center text-es-gray-100">
						{desc ||
							"Thanks for completing the assessment. You can now view the results and recommendations."}
					</p>
					<button
						onClick={() => navigate(page)}
						className="mt-6 main-border main-shadow h-11 w-full text-sm font-normal capitalize text-es-gray-200">
						{btnText || "Proceed"}
					</button>
				</div>
			</ModalContainer>
		</div>
	);
};

export const TriggerModal: React.FC<ModalProps> = ({
	title,
	desc,
	btnText,
	onClick,
	onClose,
	loading,
}) => {
	return (
		<div>
			<ModalContainer>
				<div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
					<div
						style={{
							border: "8px solid #ECFDF3",
						}}
						className="size-12 mx-auto rounded-full flex items-center justify-center bg-[#D1FADF]">
						<img src={Check} alt="" className="" />
					</div>
					<h2 className="text-lg mt-4 font-medium text-sec text-center">
						{title || "  ERP 1 Assessment Completed"}
					</h2>
					<p className="text-sm mt-4 font-normal text-center text-es-gray-100">
						{desc ||
							"Thanks for completing the assessment. You can now view the results and recommendations."}
					</p>
					<div className="mt-8  gap-8 items-center grid grid-cols-2">
						<PrimaryBtn
							className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium"
							text="Close"
							width="w-full"
							disabled={!!loading}
							onClick={() => onClose()}
							// loadingColor="#2070B8"
						/>
						<PrimaryBtn
							text={btnText || "Submit"}
							width="w-full"
							loading={!!loading}
							disabled={!!loading}
							onClick={() => onClick()}
						/>
					</div>
				</div>
			</ModalContainer>
		</div>
	);
};

export default SuccessModal;
